import TPriceHistoryList from './index.vue';

TPriceHistoryList.install = app => {
  app.component(TPriceHistoryList.name, TPriceHistoryList);
};

export default TPriceHistoryList;
